import Url from "url-parse";
import qs from "qs";
import config from "../../../config";
import { isSafeAuthRedirectUrl } from "../../../lib/auth/authRedirectUrl";
import getWebAppApiLoginUrlPrefix from "./getWebAppApiLoginUrlPrefix";
import { store } from "../../../redux/configureStore";
import { getLocale } from "../../../redux/modules/translations/selector";
import { UrlProvider } from "../../../api/UrlProvider";

export default function resolveSignupToWebinarParam(url) {
  const parsedUrl = new Url(url);

  if (!isSafeAuthRedirectUrl(url)) {
    return parsedUrl;
  }

  const loginUrlPrefix = getWebAppApiLoginUrlPrefix();
  const apiLoginUrl = `${loginUrlPrefix}?${qs.stringify({
    authRedirect: url.trim()
  })}`;

  const locale = getLocale(store.getState()) || config.defaultLocale;
  const webAppUrl = String(config.webAppUrl || "").replace(/\/?$/, "");
  const loginPath = UrlProvider.getUrl("fe.login", { locale });
  const loginPageUrl = `${webAppUrl}${loginPath}?${qs.stringify({
    redirectTo: apiLoginUrl
  })}`;

  return new Url(loginPageUrl);
}
